let form = $(".enquiry-form form");
let formGroup = $(".form-group");
let familyMember = $(".family--member");

const populatePlaceholder = (label, field, placeholder) => {
    field.attr("placeholder", placeholder);
    label.remove();
};

if(familyMember.length > 0){
    familyMember.each(function() {
        if($(this).find(".btn").length > 0){
            let name = $(this).find(".card-title").text().trim();
            let url = new URL($(this).find(".btn").attr("href").replace(/\/$/, ""));
            url.searchParams.set("enquiry", `FAO of ${name}`);
            $(this).find(".btn").attr("href", url);   
        }
    });
}

if(form.length > 0){
    let url = new URL(window.location.href);
    let enquiry = url.searchParams.get("enquiry");
    document.getElementById("akID[44][value]").value = enquiry;

    formGroup.each(function () {
        let label = $(this).find("label");
        let span = $(this).find("span");
        let input = $(this).find("input");
        let textarea = $(this).find("textarea");
        let placeholder = label.text();
        if (span.length > 0) {
            placeholder += ` (${span.text()})`;
            span.remove();
        }
        if (input.length > 0) {
            populatePlaceholder(label, input, placeholder);
        }
        if (textarea.length > 0) {
            populatePlaceholder(label, textarea, placeholder);
        }
    });

}


